<template>
  <div>
    <b-form-group
      :label="label"
      :style="!label ? 'margin-bottom:0' : ''"
    >
      <validation-provider
        #default="{ errors }"
        :rules="{required: require_}"
        name="Fluxo na G-Click"
      >
        <v-select
          ref="gClickFluxoSelect"
          v-model="value_"
          :options="fluxos"
          label="nome"
          :class="{'is-select-invalid': invalido}"
          :clearable="!require"
          :multiple="multiple"
          :disabled="disabled"
          @close="onTouch"
          @open="carregarFluxos"
          @search-change="carregarFluxosFiltrados"
          @input="enviarParaPai"
        />
        <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
      </validation-provider>
    </b-form-group>
  </div>
</template>

<style lang="scss">
.is-select-invalid  .vs__dropdown-toggle {
  border-color: #ea5455 !important;
  background-repeat: no-repeat !important;
  background-size: calc(0.725em + 0.438rem) calc(0.725em + 0.438rem) !important;
}
</style>

<script>
import { required } from '@validations'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import api from './api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'GClickFluxoSelect',
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Fluxo na G-Click',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    require: {
      type: Boolean,
      default: false,
    },
    invalido: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Object, Array],
      default: () => { },
    },
    departamentoId: {
      type: Number,
      default: 0,
    },
    filtroAdicional: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      required,
      valueAttr: null,
      foiAcessado: false,
      fluxos: [],
      fluxoPrimeiroAcesso: true,
      nomeFluxo: { 0: { value: '' } },
      depsCarregados: [],
    }
  },
  computed: {
    value_: {
      get() {
        return this.valueAttr ? this.valueAttr : this.value
      },
      set(newValue) {
        this.valueAttr = newValue
        return this.valueAttr
      },
    },
    isInvalid() {
      return this.invalid && this.foiAcessado
    },
    require_: {
      get() {
        return this.require
      },
    },
  },
  watch: {
    value(val, oldVal) {
      if (val !== oldVal) {
        this.valueAttr = val
      }
    },
    departamentoId(val, oldVal) {
      if (val !== oldVal) {
        this.value_ = null
        this.$emit('input', null)
        this.$emit('select', null)
        this.valueAttr = null
        this.fluxos = []
        this.depsCarregados = []
      }
    },
  },
  /* eslint no-underscore-dangle: 0 */
  methods: {
    carregarFluxos() {
      this.fluxos = []
      api.getFluxos()
        .then(payload => {
          this.depsCarregados = [...payload.data.content]
          this.setItensCarregados(payload.data.content)
          this.fluxoPrimeiroAcesso = false
        })
        .catch(err => {
          this.$errorFormated(err.response)
          throw err
        })
    },
    carregarFluxosFiltrados(nomeFluxo) {
      this.nomeFluxo[0].value = nomeFluxo

      api.getFluxosFiltrados(this.nomeFluxo)
        .then(payload => {
          this.setItensCarregados(payload.data)
        })
        .catch(err => {
          this.$errorFormated(err.response)
          throw err
        })
    },
    propagarParaFilho() {
      this.$refs.fluxoSelect.focus()
    },
    enviarParaPai() {
      this.$emit('select', !this.value_ ? null : this.value_)
      this.$emit('input', !this.value_ ? null : this.value_)
    },
    onTouch() {
      this.foiAcessado = true
    },
    limpar() {
      this.value_ = []
    },
    setItensCarregados(itensCarregados) {
      const itensFiltroAdicional = this.filtroAdicional(itensCarregados)
      this.fluxos = itensFiltroAdicional !== null ? itensFiltroAdicional : itensCarregados
    },
    mostrarErro(erro) {
      if (erro !== undefined && erro.includes('field is required')) {
        return 'O campo Fluxo na G-Click  é obrigatório'
      }
      return erro
    },
  },
}
</script>
